import { Card } from '@/components/ui/card'
import { transformCustomEmojisInContent } from '@/lib/draft-event'
import { createFakeEvent } from '@/lib/event'
import { cn } from '@/lib/utils'
import { useMemo } from 'react'
import Content from '../../Content'
import SlashCommandPreview from './SlashCommandPreview'

export default function Preview({ content, className }: { content: string; className?: string }) {
  const slashCommand = content.match(/^\/([^\s@]+)@(nostr:npub1[a-z0-9]+)(?=\s|$)/)
  const command = slashCommand?.[1]
  const npub = slashCommand?.[2]?.slice('nostr:'.length)
  const remainder = slashCommand ? content.slice(slashCommand[0].length) : content

  const event = useMemo(() => {
    const { content: processedContent, emojiTags } = transformCustomEmojisInContent(remainder)
    return createFakeEvent({ content: processedContent, tags: emojiTags })
  }, [remainder])

  return (
    <Card className={cn('p-3', className)}>
      {command && npub && <SlashCommandPreview command={command} author={npub} />}
      {(remainder || !command) && (
        <Content event={event} className="pointer-events-none h-full" mustLoadMedia />
      )}
    </Card>
  )
}
